
export class EstimativaCronogramaKey {
    id: number;
    mesInicio: number;
    mesFim: number;
    dias: number;
    descricao: string;
    estimativaCronogramaId: number;
    planejaId: number;
    nomeParametroPlaneja: string;
    indexOrdenacao: number;

    inicioSlideToggle: number;
    fimSlideToggle: number;
    slideToggleDisabled: boolean = false;

    diaInicio: number;
    diaFim: number;
}